import React from "react"
import Step from "../base-pages/step"

const StepCN = () => {
  return <Step lang="cn" />
}

export default StepCN
